import apiConfig from "constants/apiConfig"
import { SocialPost } from "types/influencer"
import axiosClient from "utils/axiosClient"

export interface CampaignApplySocialPostsResponse {
    items: SocialPost[]
    count: number
    last_fetched_at?: string
}

export const fetchCampaignsActivity = async (hubId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGNS_ACTIVITY.url.replace('<hubId>', hubId), {params: {...payload}});
    return response.data;
}

export const fetchCampaigns = async (hubId: string, payload?: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGNS.url.replace('<hubId>', hubId), {params: {...payload}});
    return response.data;
}

export const fetchCampaign = async (hubId: string, campaignId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN.url.replace('<hubId>', hubId).replace('<campaignId>', campaignId));
    return response.data;
}

export const fetchCampaignApplySocialPosts = async (
    hubId: string,
    socialAccountId: string,
    socialAccountPlatform: string,
    page: number
): Promise<CampaignApplySocialPostsResponse> => {
    const response = await axiosClient.get(
        apiConfig.FETCH_SOCIAL_POSTS.url.replace('<hubId>', hubId).replace('<socialAccountId>', socialAccountId),
        {
            params: {
                type: socialAccountPlatform === 'ig' ? 'REELS' : 'VIDEO',
                sort: 'views_count',
                recent: 'y',
                page,
            },
        }
    )
    return response.data
}

export const applyCampaign = async (
    hubId: string,
    campaign_id: string,
    influencer_id: string | undefined,
    social_account_id: string,
    language_id?: string,
    answers?: Record<string, string | number>,
    social_post_id?: string,
    quoted_offer?: string | number
) => {
    const response = await axiosClient.post(apiConfig.APPLY_CAMPAIGN.url.replace('<hubId>', hubId), {
        campaign_id,
        ...(influencer_id ? { influencer_id } : {}),
        social_account_id,
        ...(language_id ? { language_id } : {}),
        ...(answers ? { answers } : {}),
        ...(social_post_id ? { social_post_id } : {}),
        ...(quoted_offer ? { quoted_offer } : {}),
    })
    return response.data
}